import { h, Component } from "preact";
import style from "./style.scss";
import { connect } from "preact-redux";
import commonConstants from '../../utils/constants';
import {
	updateYearList,
	setCurrentYear
} from "../../shared/actions/getYearList";
import { setCurrentLeadUnit } from "../../shared/actions/leadSelection"
import { setMapCurrentYear } from "../../shared/actions/mapActions";
import { filterArrayByStartYear } from '../../utils/commonActionUtils'
import YearSummary from "../YearSummary";
import { yearSummaryFetchData } from "../YearSummary/actions";
import DropDown from '../leadUnit';
import index from "../YearSummary";

class EmbedSection extends Component {
	constructor(props) {
		super(props);
		this.state = {
			pageSize: this.props.endYear ? Math.min(this.props.endYear, this.props.year[0]) : this.props.year[0],
			modalState: false,
			yearArray: [],
			yearCount: localStorage.getItem('yearCount')?parseInt(localStorage.getItem('yearCount')):0

		};
	}

	handleEnterSelect(event, data) {
		if (event.keyCode == "13")
			this.handleModalClick(data)
	}


	generatePaginationList = paginationProps => {
		return paginationProps.components.pageList;
	};



	switchModalState = () => {
		this.setState(prevState => ({
			modalState: !prevState.modalState
		}));
	};

	handleModalClick = year => {
		this.setState({ pageSize: year, modalState: false });
		this.props.setCurrentYear(year);
		this.props.setMapCurrentYear(year);
	};

	handleClickOutside = e => {
		if (this.node && this.node.contains(e.target)) {
			return;
		}
		if (this.state.modalState && !this.dropDown.contains(e.target)) {
			this.switchModalState();
		}
	};

	componentWillMount() {
		this.props.updateYearList(this.props.endYear ? Math.min(this.props.endYear, this.props.year[0]) : undefined);
	}

	componentDidMount() {
		!this.props.disableDropdown &&
			window.addEventListener("mousedown", this.handleClickOutside);
		window.addEventListener("touchstart", this.handleClickOutside);
		window.addEventListener("resize", this.updateWindowDimensions);
		this.setState({
		}, () => {
			this.props.fetchYearSummary(this.state.yearArray[this.state.yearCount]);

			this.props.setMapCurrentYear(this.state.yearArray[this.state.yearCount]);
		})
	}

	componentWillReceiveProps(nextProps) {
		let yearArray = !this.props.startYear ? this.props.yearList.list : filterArrayByStartYear(this.props.yearList.list, this.props.startYear, this.props.endYear)

		this.setState({ yearArray })
		nextProps.currentYear && this.props.currentYear !== nextProps.currentYear ? this.setState({ pageSize: nextProps.currentYear, modalState: false }) : null;
	}

	componentWillUnmount() {
		window.removeEventListener("mousedown", this.handleClickOutside);
		window.removeEventListener("touchstart", this.handleClickOutside);
		window.removeEventListener("resize", this.updateWindowDimensions);
	}

	updateWindowDimensions = () => {
		this.setState({ width: window.innerWidth, height: window.innerHeight });
	};

	_TogglePrev() {
		this.setState({
			yearCount: this.state.yearCount + 1,
		}, () => {
			localStorage.setItem('yearCount',parseInt(this.state.yearCount))
			this.props.fetchYearSummary(this.state.yearArray[this.state.yearCount]);
			this.setState({ pageSize: this.state.yearArray[this.state.yearCount], modalState: false });
			this.props.setCurrentYear(this.state.yearArray[this.state.yearCount]);
			this.props.setMapCurrentYear(this.state.yearArray[this.state.yearCount]);
		})
		
	}
	_ToggleNext() {
		this.setState({
			yearCount: this.state.yearCount - 1,
		}, () => {
			localStorage.setItem('yearCount',parseInt(this.state.yearCount))
			this.props.fetchYearSummary(this.state.yearArray[this.state.yearCount]);
			this.setState({ pageSize: this.state.yearArray[this.state.yearCount], modalState: false });
			this.props.setCurrentYear(this.state.yearArray[this.state.yearCount]);
			this.props.setMapCurrentYear(this.state.yearArray[this.state.yearCount]);
		})
	}
	mapLabelToValue = (value, list) => {
		if (list.length) {
			let label = list.filter((item) => {
				return item.value == value
			})
			if (label.length) {
				return label[0].label
			} else {
				return ''
			}
		} else {
			return ''
		}
	}
	handleSelectLeadUnit = (data) => {
		this.props.setCurrentLeadUnit(data.value);
	}
	render({ paginationProps }, { pageSize, modalState }, ) {

		let { yearCount, yearArray, LeadUnit } = this.state
		const TOGGLE_PREV_DISABLED = (yearCount === yearArray.length - 1),
			TOGGLE_NEXT_DISABLED = (yearCount === 0)

		return (
			<div style={{ width: this.props.disableDropdown === false ? '20%' : this.props.leadFilter?'64%':'45%' }} class={this.props.marker ? (this.props.marker === 'embed&export' ? style.markerButtonsWrapper : style.markerYearFilter) : (this.props.ssc ? style.sscButtonsWrapper : style.buttonsWrapper)}>
				{this.props.disableDropdown === true ?
					<div className={style.yearSlider}>
						<section className={style.yearText}> Choose year</section>
						<button
							disabled={TOGGLE_PREV_DISABLED}
							className={TOGGLE_PREV_DISABLED ? style.inActivePrevious : style.previous}
							onClick={() => this._TogglePrev()}
						>{' '}</button>
						{/* <span className={style.notSelectedHeading}>{yearArray[yearCount] - 2}</span>
						<span className={style.notSelectedHeading}>{yearArray[yearCount] - 1}</span> */}
						<span className={style.annualHeading}>{yearArray[yearCount]}</span>
						<button
							disabled={TOGGLE_NEXT_DISABLED}
							className={TOGGLE_NEXT_DISABLED ? style.inActiveNext : style.next}
							onClick={() => this._ToggleNext()}
						>{' '}</button>
					</div> : null}
				{this.props.leadFilter?
				<DropDown
						placeHolder="Lead Unit"
						options={this.props.leadUnitList && this.props.leadUnitList.data}
						loading={false}
						handleClick={this.handleSelectLeadUnit}
						selectedValue=""
					/>
				:null}
						
				{
					!this.props.disableEmbedExport ?
						<span>
							{
								this.props.hideExport === 'true' ?
									null
									:
									<span class={style.buttons} onClick={() => { this.props.showExportModal ? this.props.showExportModal() : null }}>
										<b>Export</b>
									</span>
							}
							{
								this.props.hideEmbed === 'true' ?
									null
									:
									<span onClick={() => { this.props.onClickEmbed ? this.props.onClickEmbed() : null }} class={style.buttons}>
										<b>Embed</b>
									</span>
							}
						</span>
						: null
				}
			</div>
		);
	}
}
const mapStateToProps = state => {
	let yearList = state.yearList;
	if (state.tabData.tabSelected === 'signature' || state.breadCrumb.title === 'Signature Solutions') {
		var tempArray = _.map(state.yearList.list, function (o) {
			if (o >= commonConstants.SIGNATURE_SOLUTION_YEAR) return o;
		});
		yearList.list = _.without(tempArray, undefined);
	}
	const { year } = state.projectTimeline;
	let leadUnitList = state.leadUnit;
	return {
		yearList,
		year,
		leadUnitList
	};
};
const mapDispatchToProps = dispatch => {
	return {
		updateYearList: (year) => dispatch(updateYearList(year)),
		setCurrentYear: year => dispatch(setCurrentYear(year)),
		setMapCurrentYear: year => dispatch(setMapCurrentYear(year)),
		fetchYearSummary: (year) => dispatch(yearSummaryFetchData(year)),
		setCurrentLeadUnit: leadunit => dispatch(setCurrentLeadUnit(leadunit))
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(EmbedSection);



// WEBPACK FOOTER //
// ./components/EmbedSection/index.js